import React from 'react';
import {observable, action, makeObservable} from 'mobx';
import {observer} from 'mobx-react';
import store from '../../s';
import {checkout} from '../../../api';
import {hideAllModals} from '../../../util';

interface ILineCustomProps {
    id: number;
    modalId: string;
}

@observer
class ModalInfo extends React.Component<ILineCustomProps> {
    @observable gradYear: string;

    constructor(props) {
        super(props);
        this.setup = this.setup.bind(this);
        this.save = this.save.bind(this);
        this.changeGY = this.changeGY.bind(this);
        this.setup();
        makeObservable(this);
    }

    @action
    setup = () => {
        const item = store.checkout.cart.items.filter(o => o.id === this.props.id)[0];
        this.gradYear = item.gradYear.toString();
    };

    @action
    changeGY = (e: any) => {
        this.gradYear = e.target.value;
    };

    @action
    save = async (e: any) => {
        try {
            if (!isNaN(Number(this.gradYear)) && !isNaN(parseInt(this.gradYear, 10))) {
                const item = store.checkout.cart.items.filter(o => o.id === this.props.id)[0];
                item.gradYear = parseInt(this.gradYear, 10);
                const success = await checkout('line-grad-year-save');
                hideAllModals();
            }
        } catch {
            hideAllModals();
        }
    };

    render() {
        return (
            <div
                className="modal"
                tabIndex={-1}
                id={this.props.modalId}
            >
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            Edit Grad Year
                            <button
                                type="button"
                                className="btn-close"
                                data-dismiss="modal"
                                aria-label="Close"
                            ></button>
                        </div>
                        <div className="modal-body">
                            <div className="mb-2">Graduation Year</div>
                            <div>
                                <input
                                    type="text"
                                    className="form-control"
                                    value={this.gradYear}
                                    onChange={this.changeGY}
                                    maxLength={4}
                                />
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button
                                type="button"
                                className="btn btn-light"
                                data-dismiss="modal"
                            >
                                Close
                            </button>
                            <button
                                type="button"
                                className="btn btn-primary"
                                data-dismiss="modal"
                                onClick={this.save}
                            >
                                Save
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
export default ModalInfo;
